import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getPath } from '../../helpers/navigationHelpers/navigationHelpers';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

const usePageBreadcrumbs = (id: number): IPageViewModel[] => {
	const [breadcrumbs, setBreadcrumbs] = useState(null);
	const { navigation } = useSelector(({ navigationReducer }) => navigationReducer);

	useEffect(() => {
		const val = [];
		getPath(navigation[0], val, id);
		val.reverse();
		setBreadcrumbs(val);
	}, [id, navigation]);

	return breadcrumbs;
};

export default usePageBreadcrumbs;
